import PlayHistory from '@/models/game/response/play-history'
import PlayStatus from '@/models/game/response/play-status'

export default class PlayInfo {

  private _playStatus: PlayStatus
  private _playHistory: PlayHistory
  private _isGameOver: boolean

  constructor(
    data: any
  ) {
    this._playStatus = new PlayStatus(data.play_info.status)
    this._playHistory = new PlayHistory(data.play_info.count)
    this._isGameOver = data.play_info.isGameOver
  }

  get playStatus(): PlayStatus {
    return this._playStatus
  }

  get playHistory(): PlayHistory {
    return this._playHistory
  }

  get isGameOver(): boolean {
    return this._isGameOver
  }
}
